export default __webpack_public_path__ + "static/media/addOne.136d0127.svg";